import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '../api';
import { api } from '../../../models/api-url.model';
import { PortalRole } from '../../../models/portal-role.model';

@Injectable({
  providedIn: 'root',
})
export class PortalRoleService {
  private readonly apiService = inject(ApiService);

  getPortalRoles(): Observable<PortalRole[]> {
    return this.apiService.get(api.portalRolesURL);
  }
}
